import type React from "react";
import type { DesignSystemLinkHref, ShowLinkAsActive } from "../../routing/OctopusRoutingContext";
import { useOctopusLinkComponent, useIsUrlActive } from "../../routing/OctopusRoutingContext";
import { navigationBarIconLinkStyles } from "./navigationBarStyles";
export interface NavigationBarIconLinkProps {
    href: DesignSystemLinkHref;
    showLinkAsActive?: ShowLinkAsActive;
    icon: React.ReactNode;
    accessibleName: string;
}
export function NavigationBarIconLink({ href, showLinkAsActive, icon, accessibleName }: NavigationBarIconLinkProps) {
    const Link = useOctopusLinkComponent();
    const isUrlActive = useIsUrlActive();
    const isActive = isUrlActive(href, showLinkAsActive ?? "if path partially matches");
    return (<Link className={navigationBarIconLinkStyles} aria-current={isActive ? "page" : undefined} href={href} aria-label={accessibleName}>
            {icon}
        </Link>);
}
